(function($){
    'use strict';

    var 
    	$body = $('body'),
        $headerToggle = $('.js-header-toggle button'),
        $navigation = $('.js-navigation'),
        $mobileSearchButton = $('.js-mobile-search'),
        $searchOverlay = $('.js-search-overlay');
        
        $headerToggle.click(function() {
            if($headerToggle.hasClass('active')) {
                closeNavigation();
            } else {
                openNavigation();
            }

            return false;
        });

        function openNavigation() {
            $mobileSearchButton.removeClass('active');
            $searchOverlay.removeClass('active');
            $headerToggle.addClass('active');
            $navigation.addClass('active').on('click', stopNavigation);
            $body.addClass('navigation-open');
            $('.main, .footer').find('a, button').attr('tabindex', '-1');
            $('.header__logo a, .header__mobile-search button').attr('tabindex', '-1');
            $('html,body,.page-wrapper').addClass('overflow-hide');
        }

        function closeNavigation() {
            $headerToggle.removeClass('active');
            $navigation.removeClass('active').off('click', stopNavigation); 
            $body.removeClass('navigation-open');
            $('.main, .footer').find('a, button').removeAttr('tabindex');
            $('.header__logo a, .header__mobile-search button').removeAttr('tabindex');
            $('html,body,.page-wrapper').removeClass('overflow-hide');
            $navigation.find('.active').removeClass('active'); 
        }

        function stopNavigation(e) {
            e.stopPropagation();
        }
    
}(jQuery));